import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    mainFeaturedPost: {
        position: 'relative',
        color: theme.palette.common.white,
        marginBottom: theme.spacing(6),
        borderRadius: 0,
        minHeight: 420,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right center',
        backgroundSize: 'contain',
        backgroundColor: '#081426',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'stretch',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        background: 'linear-gradient(90deg, rgba(8,20,38,0.95) 0%, rgba(8,20,38,0.25) 80%)',
    },
    mainFeaturedPostContent: {
        position: 'relative',
        padding: theme.spacing(4),
        maxWidth: 640,
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(6),
        },
    },
    introTitle: {
        fontWeight: 700,
        textShadow: '2px 2px 12px rgba(0,0,0,0.35)',
    },
    introParagraph: {
        maxWidth: 520,
        color: 'rgba(255,255,255,0.85)',
    },
    chipGroup: {
        marginTop: theme.spacing(2),
        '& > *': {
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
        }
    },
    ctaGroup: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            marginRight: theme.spacing(2),
            marginBottom: theme.spacing(1.5),
        }
    },
}));

export default function intro(props: any): JSX.Element {
    const classes = useStyles();
    const { post } = props;
    const highlights = [
        'Produsen Baja Ringan',
        'Distribusi Pulau Sumatera',
        'Sertifikasi ISO & SNI'
    ];

    return (
        <>
            <Paper className={classes.mainFeaturedPost} style={{ backgroundImage: `url(${post.image})` }}>
                <div className={classes.overlay} />
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <div className={classes.mainFeaturedPostContent}>
                            <Typography component="h1" variant="h3" className={classes.introTitle} gutterBottom>
                                {post.title}
                            </Typography>
                            <Typography variant="h5" className={classes.introParagraph} paragraph>
                                {post.description}
                            </Typography>
                            <div className={classes.chipGroup}>
                                {highlights.map((text) => (
                                    <Chip key={text} label={text} color="secondary" />
                                ))}
                            </div>
                            <div className={classes.ctaGroup}>
                                <Button
                                    size="large"
                                    variant="contained"
                                    color="secondary"
                                    component={RouterLink}
                                    to="/products/page/1"
                                >
                                    Lihat Produk
                                </Button>
                                <Button
                                    size="large"
                                    variant="outlined"
                                    color="inherit"
                                    component={RouterLink}
                                    to="/news/page/1"
                                >
                                    Telusuri Berita
                                </Button>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}

intro.propTypes = {
    post: PropTypes.object,
};
